var ModuleComponent = (function () {
    function ModuleComponent() {
    }
    ModuleComponent.prototype.ngOnInit = function () {
    };
    return ModuleComponent;
}());
export { ModuleComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/module/module.component.ts.pre-build-optimizer.js